import { RequestSalePointsParams, SalePoint } from 'app/common/types/sale-points'

import { useCommonDataProvider, Options } from 'app/dataProviders/useCommonDataProvider'
import { GET_SALE_POINTS, convertResult, convertParams } from 'app/common/api/requests/food/schools/sale_points/get'


export const defaultState: Array<SalePoint> = []

type Op = Omit<Options<
  Array<SalePoint>,
  RequestSalePointsParams
>, 'requestValue' | 'convertions' | 'defaultState'>

export const useSalePoints = (options: Op = {} as Op) => {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_SALE_POINTS,
    error: 'Не удалось получить список точек продаж',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
